import { render } from "./RoundCard.vue?vue&type=template&id=4a41519f&scoped=true"
import script from "./RoundCard.vue?vue&type=script&lang=js"
export * from "./RoundCard.vue?vue&type=script&lang=js"

import "./RoundCard.vue?vue&type=style&index=0&id=4a41519f&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a41519f"]])

export default __exports__